import { action } from '@ember/object';
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import config from 'cio/config/environment';
import { timeout } from 'ember-concurrency';

export enum StaticSidebarId {
  HelpDropdown = 'help-dropdown',
  CurrentPlans = 'current-plans',
  RelationshipsTable = 'relationships-table',
  CampaignTrigger = 'campaign-trigger',
  AvailablePlans = 'available-plans',
  GenerateLiquidWithAi = 'generate-liquid-with-ai',
}

// there can be multiple relationship tables on the page, so we need to make sure that the sidebarId is unique
// in the RelationshipsTableComponent we append an object type id to the sidebarId
export type SidebarId = StaticSidebarId | `${StaticSidebarId.RelationshipsTable}-${string}`;

export default class SidebarService extends Service {
  @tracked activeSidebarId: SidebarId | null = null;
  @tracked closingSidebarId: SidebarId | null = null; // helps with closing transition when used as Overlay sidebar

  @tracked sidebarPanelClass = {} as Record<SidebarId, string>;

  get isOpen() {
    return this.activeSidebarId != null;
  }

  @action
  toggle(id: SidebarId) {
    if (this.activeSidebarId === id) {
      this.close();
    } else {
      this.open(id);
    }
  }

  @action
  open(id: SidebarId) {
    this.activeSidebarId = id;
    this.closingSidebarId = null;
  }

  @action
  async close() {
    this.closingSidebarId = this.activeSidebarId;
    this.activeSidebarId = null;
    await timeout(config.APP.shortDelay);
    this.closingSidebarId = null;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    sidebar: SidebarService;
  }
}
